import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useIntl, FormattedMessage, defineMessages } from "react-intl";
import moment from "moment";
import Modal from "../common/modal/modal";
import Button from "../common/button/button";
import { Gantt } from "../gantt/gantt";
import { requestAssignTask, clearAssignmentOverlaps } from "../../redux/assignment/assignmentActions";

const messages = defineMessages({
    showOverlapsTitle: {
        id: "show-overlaps-dialog.title",
        defaultMessage: "Overlapping WOs",
        description: "Overlapping WOs dialog title",
    },
});

export const ShowOverlapsModal = (props) => {
    const { assignment, technician, show, workOrder } = props;
    const workOrderNumber = workOrder ? workOrder.workOrderNumber : "";
    const intl = useIntl();

    var overlaps = [];
    var startDay = moment().startOf("day");

    if (show && assignment) {
        // overlaps do not include the current task so add it as the first item
        // overlaps date need to be converted to moment from strings
        overlaps = [assignment, ...props.overlaps].map((overlap) => ({
            ...overlap,
            //taskAssignedDate: moment(Date.parse(overlap.taskAssignedDate))
            scheduledDate: moment(overlap.scheduledDate),
        }));

        //startDay = moment(overlaps[0].taskAssignedDate).startOf('day');
        startDay = moment(overlaps[0].scheduledDate).startOf("day");
    }

    return (
        <Modal
            show={show}
            title={intl.formatMessage(messages.showOverlapsTitle)}
            onClose={() => props.clearAssignmentOverlaps()}
            buttons={[
                <Button key="1" onClick={() => props.clearAssignmentOverlaps()} tertiary>
                    <FormattedMessage
                        id="show-overlaps-dialog.cancel-button"
                        defaultMessage="Cancel"
                        description="Overlapping WOs dialog cancel button caption"
                    />
                </Button>,
                <Button key="0" onClick={() => props.requestAssignTask(props.workOrder, props.technician, props.assignment, true)}>
                    <FormattedMessage
                        id="show-overlaps-dialog.accept-button"
                        defaultMessage="Ignore overlaps"
                        description="Overlapping WOs dialog accept button caption"
                    />
                </Button>,
            ]}>
            <p>
                <FormattedMessage
                    id="show-overlaps-dialog.description"
                    defaultMessage="Assigning WO-{workOrderNumber} to selected resource overlaps with the following existing work order assignment:"
                    description="Overlapping WOs dialog description"
                    values={{
                        workOrderNumber,
                    }}
                />
            </p>

            {show && assignment && (
                <div
                    style={{
                        width: "800px",
                        marginBottom: "21px",
                    }}>
                    <Gantt
                        showSidebar={false}
                        ganttDate={startDay}
                        assignments={overlaps}
                        timeRange={props.timeRange}
                        technicians={technician ? [technician] : []}
                    />
                </div>
            )}
        </Modal>
    );
};

const mapStateToProps = (state) => ({
    technicians: state.technicians,
    overlaps: state.assignments.overlaps,
    show: state.assignments.overlaps.length > 0,
    timeRange: state.domain.timeRange,
    ...state.assignments.assignTaskRequest,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            requestAssignTask,
            clearAssignmentOverlaps,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(ShowOverlapsModal);
